import { Block, IconButton } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { HelpDrawer } from '../../components/ReferenceBar/HelpDrawer/HelpDrawer.js';
import { ResizableDrawerLayout } from '../../layout/ResizableDrawerLayout.js';
import { setReferenceViewOpen } from '../../redux/features/referenceBarUISlice.js';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.js';
import { selectDeviceWidth } from '../../redux/features/selectors/uiSelectors.js';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.js';
import { Tkv2ReferenceViewModule } from './Tkv2ReferenceViewModule.js';
import { useAutoOpenHelpDrawer } from './hooks/useAutoOpenHelpDrawer.js';
import { useHelpDrawerPageID } from './hooks/useHelpDrawerPageID.js';

export const Tkv2ReferenceViewDrawer = ({ children }: PropsWithChildren) => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const dispatch = useAppDispatch();

  const { pageID } = useHelpDrawerPageID();
  useAutoOpenHelpDrawer({ pageID });

  return (
    <Block className="reference-view-drawer">
      <div className="reference-view-drawer-desktop">
        <ResizableDrawerLayout
          direction="horizontal"
          isOpen={referenceViewOpen}
          onClose={() => dispatch(setReferenceViewOpen(false))}
          drawerContent={
            selectedDataSheet === 'help-drawer' ? (
              <HelpDrawer pageID={pageID} />
            ) : (
              <Tkv2ReferenceViewModule isPopout={false} dataSheet={selectedDataSheet} />
            )
          }
          isResizable
          defaultSize={33}
        >
          {children}
        </ResizableDrawerLayout>
      </div>
      {deviceWidth === 'phone' && (
        <div className="reference-view-drawer-mobile">
          {referenceViewOpen ? (
            <div>
              <div className="reference-view-close-button">
                <IconButton
                  icon="close-circle"
                  variant="tertiary"
                  onClick={() => dispatch(setReferenceViewOpen(false))}
                  ariaLabel="close"
                  iconSize="lg"
                  size="sm"
                />
              </div>
              {selectedDataSheet === 'help-drawer' ? (
                <HelpDrawer pageID={pageID} />
              ) : (
                <Tkv2ReferenceViewModule isPopout={false} dataSheet={selectedDataSheet} />
              )}
            </div>
          ) : (
            children
          )}
        </div>
      )}
    </Block>
  );
};
